import React from 'react';
import { useTranslation } from 'react-i18next';
import Container from '../components/container';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCode, faUsers, faLifeRing } from '@fortawesome/free-solid-svg-icons';

const WhyPathConnectSection = () => {
  const { t } = useTranslation('home');
  
  // Map icons to keys
  const iconMap = {
    technical: faCode,
    personal: faUsers,
    support: faLifeRing
  };
  
  return (
    <section className="animate-section relative py-20 lg:py-24">
      <Container>
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold mb-6">{t('whyPathConnect.title')}</h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            {t('whyPathConnect.subtitle')}
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {t('whyPathConnect.benefits', { returnObjects: true }).map((benefit, index) => (
            <div
              key={benefit.key}
              className="card-hover bg-gray-800/50 border border-gray-700/50 rounded-xl p-8 text-center"
              style={{
                animationDelay: `${index * 100}ms`,
                transitionDelay: `${index * 100}ms`
              }}
            >
              <div className="w-16 h-16 rounded-full bg-primary/20 mx-auto flex items-center justify-center mb-6">
                <FontAwesomeIcon icon={iconMap[benefit.key]} className="text-primary text-xl" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3">{benefit.title}</h3>
              <p className="text-gray-300">{benefit.description}</p>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default WhyPathConnectSection;